<template>
  <div class="adv-product-gallery">
    <div class="product-page-single-img" v-if="mainMedia">
      <a v-if="mainMedia.type === 'image'" :href="mainMedia.large" class="image-popup-vertical-fit">
        <AdvHtmlPicture
          :srcset-image="mainMedia.original_raw"
          :srcset-profile="'from_w600'"
          :width="540"
          :height="540"
          img-class="imagepop"
          :alt="productData.productName"
        />
      </a>
      <a v-else-if="hasThumbnail(mainMedia.type)" href="#" @click.prevent="openVideoModal(mainMedia)" class="image-popup-vertical-fit">
        <img
          :src="resolveMediaThumbnail(mainMedia)"
          :width="540"
          :height="540"
          class="imagepop"
          :alt="`${productData.productName} Video`"
        />
        <img v-if="hasThumbnail(mainMedia.type)" src="/ui/main/img/video_cover.svg" alt="Play Video" class="video-overlay" />
      </a>
    </div>

    <div class="native_slider prod-gallery-row" v-if="galleryMedia.length > 1">
      <div class="native_slider-btn native_slider-btn-prev" data-scroll_left_by="-1">Prev</div>
      <div class="native_slider-lg">
        <div
          class="native_slider-li prod-gallery-thumb"
          v-for="(media, index) in galleryMediaSorted"
          :key="index"
          @click="onMediaClick(media)"
        >
          <div class="thumbnail_wrapper">
            <AdvHtmlPicture
              v-if="media.type === 'image'"
              :srcset-image="media.original_raw"
              :srcset-profile="'from_w280'"
              :width="140"
              :height="140"
              img-class="prod-gallery-thumb-img"
              :alt="media.type === 'image' ? productData.productName : `${productData.productName} Video`"
            />
            <img
              v-else
              :src="resolveMediaThumbnail(media)"
              :alt="`Video Thumbnail ${media.type}`"
              class="prod-gallery-thumb-img"
            />
            <img
              v-if="hasThumbnail(media.type)"
              src="/ui/main/img/video_cover.svg"
              alt="Video Overlay"
              class="video-overlay-thumb"
            />
          </div>
        </div>
      </div>
      <div class="native_slider-btn native_slider-btn-next" data-scroll_left_by="1">Next</div>
    </div>

    <div v-if="isModalOpen" class="modal-overlay" @click.self="closeVideoModal">
      <div class="modal-content">
        <button class="close-button" @click="closeVideoModal">×</button>
        <iframe
          v-if="currentVideo"
          :src="videoEmbedUrl"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import productMixin from './mixins/productMixins'
import AdvHtmlPicture from '../../vue/components/AdvHtmlPicture.vue'

export default {
  name: 'AdvProductGallery',
  components: {
    AdvHtmlPicture,
  },
  props: {
    productId: {
      type: Number,
      required: true,
    },
    mainImageFirst: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [productMixin],
  data() {
    return {
      productCodeId: null,
      mainMedia: null,
      galleryMedia: [
        {
          is_main: '1',
          large: store.state.noImage,
          medium: store.state.noImage,
          original: store.state.noImage,
          original_raw: store.state.noImage,
          small: store.state.noImage,
          uri: '',
          type: 'image',
        },
      ],
      isModalOpen: false,
      currentVideo: null,
    };
  },
  watch: {
    selectedProductCodeId(val) {
      this.productCodeId = val
      this.setUpGalleryUpdate()
    },
    selectedAttributeId(attributeId) {
      const productCode = this.productData.productCodes.find(item =>
        item.productCodeAttributes.includes(attributeId)
      )
      if (productCode) {
        this.setUpGalleryUpdate(productCode.productCodeId);
      }
    },
  },
  mounted() {
    this.setProductCodeId()
    this.setUpGalleryUpdate()
  },
  computed: {
    selectedAttributeId() {
      return store.getters.getSelectedAttributeId;
    },
    selectedProductCodeId() {
      return store.getters.getSelectedProductCodeId;
    },
    galleryMediaSorted() {
      if (!this.mainImageFirst) {
        return this.galleryMedia
      }
      const images = [...this.galleryMedia]
      return images.sort(function (a, b) { return a.is_main === '1' ? -1 : b.is_main === '1' ? 1 : 0 })
    },
    videoEmbedUrl() {
      if (!this.currentVideo) return null;
      const videoType = this.currentVideo.type.toLowerCase();
      const videoId = this.currentVideo.uri;
      switch (videoType) {
        case 'youtube':
          return `https://www.youtube.com/embed/${videoId}`;
        case 'vimeo':
          return `https://player.vimeo.com/video/${videoId}`;
        case 'tiktok':
          return `https://www.tiktok.com/embed/v3/${videoId}`;
        case 'instagram':
          return `https://www.instagram.com/reel/${videoId}/embed/`;
        case 'facebook':
          return `https://www.facebook.com/plugins/video.php?href=https://www.facebook.com/watch?v=${videoId}`;
        default:
          return null;
      }
    },
  },
  methods: {
    setUpGalleryUpdate(codeId = null) {
      this.productCodeImages(codeId)
      this.setMainMedia()
    },
    setProductCodeId() {
      if (this.selectedProductCodeId) {
        this.productCodeId = this.selectedProductCodeId
      } else {
        const firstKey = Object.keys(this.productData.images)[0]
        this.productCodeId = firstKey ? parseInt(firstKey) : null
      }
    },
    productCodeImages(codeId = null) {
      if (codeId !== null) {
        this.galleryMedia = this.productData.images[parseInt(codeId)] || []
      } else if (this.productCodeId !== null) {
        this.galleryMedia = this.productData.images[this.productCodeId] || []
      } else {
        this.galleryMedia = []
      }
    },
    setMainMedia(media = null) {
      if (media) {
        this.mainMedia = media
      } else {
        this.mainMedia = this.galleryMedia.find(media => media.is_main === '1') || this.galleryMedia[0];
      }
    },
    isVideo(type) {
      return type !== 'image';
    },
    hasThumbnail(type) {
      return !['image', 'vimeo', 'tiktok', 'facebook', 'instagram'].includes(type);
    },
    openVideoModal(media) {
      if (this.isVideo(media.type)) {
        this.currentVideo = media;
        this.isModalOpen = true;
      }
    },
    closeVideoModal() {
      this.isModalOpen = false;
      this.currentVideo = null;
    },
    onMediaClick(media) {
      if (this.isVideo(media.type)) {
        this.openVideoModal(media);
      }

      if (this.hasThumbnail(media.type) || media.type === 'image') {
        this.setMainMedia(media);
      }
    },
    /**
     * Resolves the appropriate image URL for a media object.
     * For images, it returns the original raw URL.
     * For videos, it returns the constructed thumbnail URL based on the video type.
     * @param {Object} media - The media object.
     * @returns {String} - The resolved image URL.
     */
    resolveMediaThumbnail(media) {
      const videoType = media.type.toLowerCase();
      const videoId = media.uri;

      if (!videoType || !videoId) {
        return '/ui/main/img/no_video.jpg';
      }

      switch (videoType) {
        case 'youtube':
          return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
        case 'vimeo':
          return '/ui/main/img/no_video.jpg';
        case 'tiktok':
          return '/ui/main/img/no_video.jpg';
        case 'instagram':
          return '/ui/main/img/no_video.jpg';
        case 'facebook':
          return '/ui/main/img/no_video.jpg';
        default:
          return '/ui/main/img/no_photo.jpg';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.adv-product-gallery {
  display: flex;
  flex-direction: column;
}

.image-popup-vertical-fit {
  display: block;
  position: relative;
}

.imagepop,
.video-thumb {
  object-fit: contain;
  max-width: 100%;
}

.video-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  pointer-events: none;
}

.native_slider-lg {
  gap: 5px;
  grid-auto-columns: calc(33% - 5px);
  @media screen and (max-width: 1199px) {
    grid-auto-columns: calc(50% - 5px);
  }
}

.thumbnail_wrapper {
  position: relative;
  display: grid;
  height: 100%;
  align-items: center;
  border: 1px solid #eceff1;
}

::v-deep .prod-gallery-thumb-img {
  object-fit: contain;
  width: 100%;
  max-width: 100%;
  padding: 5px;
  cursor: pointer;
}

.video-overlay-thumb {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 30px;
  pointer-events: none;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  width: 80%;
  max-width: 800px;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
}

.modal-content iframe {
  width: 100%;
  height: 450px;
  border: none;
  border-radius: 4px;
}

.close-button {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #ff5f5f;
  border: none;
  border-radius: 50%;
  color: #fff;
  width: 30px;
  height: 30px;
  font-size: 20px;
  cursor: pointer;
}

.close-button:hover {
  background-color: #ff3b3b;
}

.native_slider-btn {
  width: 36px;
  height: 36px;
  background-color: #fff;
  background-position: center center;
  background-repeat: no-repeat;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  box-shadow: none;
  cursor: pointer;
  user-select: none;
  padding: 10px;
  margin: 0 5px;

  &-next {
    background-image: url(../img/slick-next-sm.png)
  }

  &-prev {
    background-image: url(../img/slick-prev-sm.png)
  }
}

.native_slider-btn:hover {
  background-color: #e2e6ea;
}

::v-deep .imagepop {
  object-fit: contain;
  max-width: 100%;
}
</style>
